<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <loading v-if="!loadData" :active="isLoading" :can-cancel="false" :is-full-page="false" :loader="'dots'" :transition="'fade'" :color="'#036eb7'" />
  <loading v-if="loadData" :active="isLoading" :background-color="loadData.background" :can-cancel="loadData.cancel" :is-full-page="loadData.full" :loader="loadData.loader" :transition="loadData.transition" :color="loadData.color">
      <template #after><span :style="loadData.textStyle">{{ loadData.afterText }}</span></template>
  </loading>
</template>

<script>
/* eslint-disable vue/no-dupe-keys */
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
  props: ['isLoading', 'loadData'],
  data() {
    return {};
  },
  components: {
    loading,
  },
};
</script>
